<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <div class="d-flex flex-column">
          <strong>وبکارت</strong>
          <small v-if="POM == 'P'" class="text-muted text-small"
            >گزارش جزییات کارکرد دوره ای
          </small>
          <small v-if="POM == 'M'" class="text-muted text-small"
            >گزارش جزییات کارکرد ماهانه
          </small>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div id="viewer" dir="ltr"></div>
  </div>
</template>

<script>
import personelMonthWorkReportFile from "../../assets/reports/personelMonthWorkDetailTestIO.mrt";
import personelPeriodWorkReportFile from "../../assets/reports/personelPeriodWorkDetailTestIO.mrt";
import personelMonthWorkDetailsReportFile from "../../assets/reports/personelMonthWorkDetailTestDetails.mrt";
import personelPeriodWorkDetailReportFile from "../../assets/reports/personelPeriodWorkDetailTestDetails.mrt";
import reportTexts from "../../assets/js/reports";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";



export default {
  data() {
    return {
      visible: false,
      dataLoaded: false,
      infoDataSet: null,
      personelIOInfo: null,
      perno: "",
      dedicatedPerno: "",
      year: "",
      period: "",
      POM: "",
      details:"",
      IOInfoDataSet: [],
      periodWorkDetail: {},
    };
  },
  mounted() {
    
    this.loadPage();
  },
  watch: {
    dataLoaded(newVal) {
      if (newVal) {
        debugger
        this.showReport();
      }
    },
  },
  methods: {
    loadPage() {
     debugger;
      var args = this.$route.query;
      this.perno = this.$store.state.auth.auth.username;
      this.year = args.Y;
      this.period = args.P;
      this.POM = args.POM;
      this.dedicatedPerno = args.dp;
      if(args.details){
        this.details=args.details;
      }

      this.ValidateQueryInputs();
    },
    ValidateQueryInputs() {
      // //debugger;
      if (!this.perno) {
        this.transferPage();
        return;
      }
      if (!this.year) {
        this.transferPage();
        return;
      }
      if (!this.period) {
        this.transferPage();
        return;
      }
      if (!this.POM || (this.POM != "M" && this.POM != "P")) {
        this.transferPage();
        return;
      }
      if (!this.dedicatedPerno) {
        this.transferPage();
        return;
      }
      this.getData();
    },
    transferPage() {
      //todo : error wrong page
    },
    async getData() {
      //debugger;
      var moment = require("jalali-moment");

      var infoDataSet = {};
      if (EosUtils.isWebKartAdmin()) {
        infoDataSet.perno = "-";
        infoDataSet.personName = "مدير وب کارت";
      } else {
        infoDataSet.perno = this.perno;
        infoDataSet.personName =
          this.$store.state.personel.personelDetail.PersonName;
      }

      infoDataSet.timeNow = moment().locale("fa").format("YYYY/MM/DD HH:mm");
      infoDataSet.companyName = "";
      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        infoDataSet.companyName = GetCustomerNameResponse.data;
      }

      infoDataSet.year = this.year;
      infoDataSet.period = this.period;

      if (this.dedicatedPerno == this.perno) {
        infoDataSet.dedicatePersonName = infoDataSet.personName;
        infoDataSet.dedicatePerson = infoDataSet.perno;
      } else {
        infoDataSet.dedicatePersonName = "";
        infoDataSet.dedicatePerson = this.dedicatedPerno;
        var EosPersonelDetailResponse = await this.$store.dispatch(
          "EosPersonelDetail",
          { perno: this.dedicatedPerno }
        );
        //debugger;
        if (EosPersonelDetailResponse.type === ResultType.success) {
          var personelDetails = EosPersonelDetailResponse.data;
          infoDataSet.dedicatePersonName = personelDetails.PersonName;
        }
      }

      this.infoDataSet = infoDataSet;

      var promises = [];
      promises.push(this.loadIOInfoData());
      promises.push(this.loadPeriodWorkDetail());

      Promise.all(promises).then((result) => {
        console.log(result);
        console.log(result);
        this.dataLoaded = true;
      });

      /*if (this.POM == "P") {
        this.getPersonelPeriodWork();
      } else if (this.POM == "M") {
        this.getPersonelMonthWork();
      }*/
    },
    loadIOInfoData() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.period);
      params.append("year", this.year);
      params.append("employeeId", this.dedicatedPerno);

      return this.$store
        .dispatch("GetFullPeriodIoInfo", { params })
        .then((result) => {
          if (result.type === "success") {
            var data = [];
            data = result.data;
            this.IOInfoDataSet = data;
            // //debugger;
          }
        });
    },
    loadPeriodWorkDetail() {
      const params = new URLSearchParams();
      params.append("period", this.period);
      params.append("year", this.year);
      params.append("perno", this.dedicatedPerno);
      debugger
      if (this.POM == "P") {
        params.append("isPeriod", true);
      } else if (this.POM == "M") {
        params.append("isPeriod", false);
      }

      return this.$store
        .dispatch("GetPersonPeriodWorkDetail", { params })
        .then((result) => {
          if (result.type === "success") {
            // //debugger;
            this.periodWorkDetail = result.data.Table[0];
          }
        });
    },

    showReport() {
      window.Stimulsoft.Base.StiLicense.key = reportTexts.getStimulKey();
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      /*options.appearance.fullScreenMode = true;
      options.toolbar.displayMode =
        window.Stimulsoft.Viewer.StiToolbarDisplayMode.Separated;*/
      var viewer = new window.Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      let report = window.Stimulsoft.Report.StiReport.createNewReport();
// //debugger;
      if (this.POM == "P") {
        if (this.details == "true") {
          report.load(personelPeriodWorkDetailReportFile);
        }
        else {
          report.load(personelPeriodWorkReportFile);
        }
      } else if (this.POM == "M") {
        if (this.details == "true") {
          report.load(personelMonthWorkDetailsReportFile);

        }
        else {
          report.load(personelMonthWorkReportFile);
        }

      }

      report.dictionary.variables.getByName("dedicatePersonName").valueObject =
        this.infoDataSet.dedicatePersonName;
      report.dictionary.variables.getByName("dedicatePerson").valueObject =
        this.infoDataSet.dedicatePerson;
      report.dictionary.variables.getByName("ReportDate").valueObject =
        this.infoDataSet.timeNow;
      report.dictionary.variables.getByName("CompanyName").valueObject =
        this.infoDataSet.companyName;
      report.dictionary.variables.getByName("period").valueObject =
        this.infoDataSet.period;
      report.dictionary.variables.getByName("year").valueObject =
        this.infoDataSet.year;
      report.dictionary.variables.getByName("Perno").valueObject =
        this.infoDataSet.perno;
      report.dictionary.variables.getByName("PersonName").valueObject =
        this.infoDataSet.personName;

        if(this.details=="true"){

          this.convertToHourse( this.periodWorkDetail);
          report.regData("dbYear", "periodWorkDetailDS", this.periodWorkDetail);
        }
        else{
          report.regData("d1", "d1", this.IOInfoDataSet);
        }

      
      // report.regData("d1", "d2", this.periodWorkDetail);
      // report.regData("dbYear", "periodWorkDetailDS", this.periodWorkDetail);
      // report.regData("dbYear", "d1", this.IOInfoDataSet);
      
      
//debugger;
console.log("dd : "+report)
      viewer.report = report;
      viewer.renderHtml("viewer");
    },
    ConvertMinToHour(minutes) {
      
      if (minutes == 0) {
          return '00:00'
      }
      
      if (minutes) {
          //debugger
          minutes = minutes.toString().replace('-', '')
          var h = Math.floor(minutes / 60);
          var m = minutes % 60;
          h = h < 10 ? '0' + h : h;
          m = m < 10 ? '0' + m : m;
          return h + ':' + m;
      }
      return '00:00'
  },
    convertToHourse(data){
      this.periodWorkDetail.NONWORKTOTAL= this.ConvertMinToHour(data.NONWORKTOTAL);
      this.periodWorkDetail.NW_SPECIAL= this.ConvertMinToHour(data.NW_SPECIAL);
      this.periodWorkDetail.NW_ABSENT= this.ConvertMinToHour(data.NW_ABSENT);
      this.periodWorkDetail.NW_LEAVENOTPERM= this.ConvertMinToHour(data.NW_LEAVENOTPERM);
      this.periodWorkDetail.NW_EARLY= this.ConvertMinToHour(data.NW_EARLY);
      this.periodWorkDetail.NW_LATE= this.ConvertMinToHour(data.NW_LATE);
      this.periodWorkDetail.WORKTOTAL= this.ConvertMinToHour(data.WORKTOTAL);
      this.periodWorkDetail.EARLYPERMAMOUNT= this.ConvertMinToHour(data.EARLYPERMAMOUNT);
      this.periodWorkDetail.LATEPERMAMOUNT= this.ConvertMinToHour(data.LATEPERMAMOUNT);
      this.periodWorkDetail.NIGHTWORK= this.ConvertMinToHour(data.NIGHTWORK);
      this.periodWorkDetail.WWORK= this.ConvertMinToHour(data.WWORK);
      this.periodWorkDetail.EW_HOLINOTPERM= this.ConvertMinToHour(data.EW_HOLINOTPERM);
      this.periodWorkDetail.EW_HOLIPERM= this.ConvertMinToHour(data.EW_HOLIPERM);
      this.periodWorkDetail.EW_NORMNOTPERM= this.ConvertMinToHour(data.EW_NORMNOTPERM);
      this.periodWorkDetail.EW_NORMPERM= this.ConvertMinToHour(data.EW_NORMPERM);
      this.periodWorkDetail.EW_HoliInMission= this.ConvertMinToHour(data.EW_HoliInMission);
      this.periodWorkDetail.EW_NormInMission= this.ConvertMinToHour(data.EW_NormInMission);
      this.periodWorkDetail.EW_BreakNotPerm= this.ConvertMinToHour(data.EW_BreakNotPerm);
      this.periodWorkDetail.EW_BreakPerm= this.ConvertMinToHour(data.EW_BreakPerm);
      this.periodWorkDetail.EW_SPECIAL= this.ConvertMinToHour(data.EW_SPECIAL);
      this.periodWorkDetail.EW_INMISSION= this.ConvertMinToHour(data.EW_INMISSION);
      this.periodWorkDetail.EXTRAWORKTOTAL= this.ConvertMinToHour(data.EXTRAWORKTOTAL);
      this.periodWorkDetail.PRESENCEINDMOR= this.ConvertMinToHour(data.PRESENCEINDMOR);
      this.periodWorkDetail.LEAVEOFABSPAY= this.ConvertMinToHour(data.LEAVEOFABSPAY);
      this.periodWorkDetail.LEAVEOFABSNOPAY= this.ConvertMinToHour(data.LEAVEOFABSNOPAY);
      this.periodWorkDetail.MORKHASIRATION= this.ConvertMinToHour(data.MORKHASIRATION);
      this.periodWorkDetail.ORDMOR= this.ConvertMinToHour(data.ORDMOR);
      this.periodWorkDetail.MISSION= this.ConvertMinToHour(data.MISSION);
      this.periodWorkDetail.PRESENCEINDMAM= this.ConvertMinToHour(data.PRESENCEINDMAM);
      this.periodWorkDetail.HG_MINUTES= this.ConvertMinToHour(data.HG_MINUTES);
      this.periodWorkDetail.HT_MINUTES= this.ConvertMinToHour(data.HT_MINUTES);
      this.periodWorkDetail.FORGIVEN_LATEAMOUNT= this.ConvertMinToHour(data.FORGIVEN_LATEAMOUNT);

    },
    
  },
};
</script>

<style>
</style>